import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./BioNoteModal.module.scss";
import { messages } from "../Case1ArtisticPov.messages";
import { useUi } from "@jelly/lesson";

const BIO_SLIDES_DATA = [
  {
    title: messages.bioMarloweTitle,
    content: messages.bioMarloweDescription,
    link: messages.bioMarloweLink,
  },
  {
    title: messages.bioSkalTitle,
    content: messages.bioSkalDescription,
    link: messages.bioSkalLink,
  },
  {
    title: messages.bioLauraTitle,
    content: messages.bioLauraDescription,
    link: messages.bioLauraLink,
  },
];

type BioNoteModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const BioNoteModal: React.FC<BioNoteModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  const slides = BIO_SLIDES_DATA.map((data, index) => {
    let linkToPresent = "placeholder-link";
    try {
      const url = new URL(formatMessage(data.link));
      linkToPresent = url.host;
    } catch {
      // ...
    }

    return (
      <div key={index} className={styles.slide}>
        <div className={styles.title}>{formatMessage(data.title)}</div>
        <div className={styles.content}>{formatMessage(data.content)}</div>
        {data.link && (
          <div className={styles.link}>
            <ui.Button
              size="small"
              shape={"normal"}
              theme={"primary"}
              onClick={() => window.open(formatMessage(data.link))}
            >
              {linkToPresent}
            </ui.Button>
          </div>
        )}
      </div>
    );
  });

  return <CarouselModal {...props}>{slides}</CarouselModal>;
};

//TODO: override scrollbars colors
